import script from "./KnowledgeBase.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBase.vue?vue&type=style&index=0&id=d899620c&scoped=true&lang=css"
import "./KnowledgeBase.vue?vue&type=style&index=1&id=d899620c&lang=css"
import "./KnowledgeBase.vue?vue&type=style&index=2&id=d899620c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d899620c"]])

export default __exports__